var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('Cover'),_c('div',{staticClass:"container lg:px-12 md:px-12 px-4 mb-16"},[_c('Content')],1),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555"},[_c('DownloadApp'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }